/** Raw autosomal DNA uploads — genealogy providers only (not medical reports). */

export const DNA_UPLOAD_ALLOWED_EXTENSIONS = ['.zip', '.txt', '.csv'];

export const DNA_UPLOAD_REJECTED_EXTENSIONS = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png'];

export const DNA_UPLOAD_INVALID_FILE_MESSAGE =
  'This does not look like a raw DNA data file. Please upload a .zip, .txt, or .csv file from your DNA provider.';

export const DNA_UPLOAD_MAX_BYTES = 50 * 1024 * 1024;

export function getDnaFileExtension(filename) {
  if (!filename || typeof filename !== 'string') return '';
  const idx = filename.lastIndexOf('.');
  return idx >= 0 ? filename.slice(idx).toLowerCase() : '';
}

/**
 * @param {File} file
 * @returns {{ ok: true } | { ok: false, error: string }}
 */
export function validateDnaUploadFile(file) {
  if (!file) {
    return { ok: false, error: 'Please select a file to upload' };
  }

  const ext = getDnaFileExtension(file.name);

  if (DNA_UPLOAD_REJECTED_EXTENSIONS.includes(ext) || !DNA_UPLOAD_ALLOWED_EXTENSIONS.includes(ext)) {
    return { ok: false, error: DNA_UPLOAD_INVALID_FILE_MESSAGE };
  }

  if (file.size > DNA_UPLOAD_MAX_BYTES) {
    return { ok: false, error: 'File size must be under 50MB' };
  }

  return { ok: true };
}

/** @param {string} filename */
export function guessDnaProviderFromFilename(filename) {
  const lower = (filename || '').toLowerCase();
  if (lower.includes('ancestry')) return 'ancestry';
  if (lower.includes('myheritage')) return 'myheritage';
  if (lower.includes('ftdna') || lower.includes('familytree')) return 'ftdna';
  if (lower.includes('gedmatch')) return 'gedmatch';
  if (lower.includes('living')) return 'other';
  if (lower.includes('23andme')) return 'unknown';
  return 'unknown';
}
